var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardsShowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 7.54545C1 6.92074 1 6.3812 1.00994 5.90909C1.03646 4.64973 1.13373 3.87016 1.49047 3.23368C1.9219 2.46392 2.61031 1.83809 3.45704 1.44588C4.41965 1 5.67976 1 8.2 1H11.8C14.3202 1 15.5804 1 16.543 1.44588C17.3897 1.83809 18.0781 2.46392 18.5095 3.23368C18.8663 3.87016 18.9635 4.64973 18.9901 5.90909C19 6.3812 19 6.92074 19 7.54545C19 9.83658 19 10.9821 18.5095 11.8572C18.0781 12.627 17.3897 13.2528 16.543 13.645C15.5804 14.0909 14.3202 14.0909 11.8 14.0909H8.2C5.67976 14.0909 4.41965 14.0909 3.45704 13.645C2.61031 13.2528 1.9219 12.627 1.49047 11.8572C1 10.9821 1 9.83658 1 7.54545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00994 5.90909C1 6.3812 1 6.92074 1 7.54545C1 9.83658 1 10.9821 1.49047 11.8572C1.9219 12.627 2.61031 13.2528 3.45704 13.645C4.41965 14.0909 5.67976 14.0909 8.2 14.0909H11.8C14.3202 14.0909 15.5804 14.0909 16.543 13.645C17.3897 13.2528 18.0781 12.627 18.5095 11.8572C19 10.9821 19 9.83658 19 7.54545C19 6.92074 19 6.3812 18.9901 5.90909M1.00994 5.90909C1.03646 4.64973 1.13373 3.87016 1.49047 3.23368C1.9219 2.46392 2.61031 1.83809 3.45704 1.44588C4.41965 1 5.67976 1 8.2 1H11.8C14.3202 1 15.5804 1 16.543 1.44588C17.3897 1.83809 18.0781 2.46392 18.5095 3.23368C18.8663 3.87016 18.9635 4.64973 18.9901 5.90909M1.00994 5.90909H18.9901",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsShowIcon);
export default __webpack_public_path__ + "static/media/cards_show_icon.66ca53f85bf087a394b37eaaa1a7f5eb.svg";
export { ForwardRef as ReactComponent };